import { AnswerForm } from '../components/AnswerForm';
import type { GameModuleProps } from '../types/game';
import { validateModuleAnswer } from '../utils/answers';

export function SecretCodeModule({ module, onComplete }: GameModuleProps<'secret-code'>) {
  return <AnswerForm prompt={module.config.prompt} placeholder={module.config.placeholder} secret
    inputMode={module.config.inputMode}
    onValidate={(answer) => validateModuleAnswer(module, answer)}
    onSolved={(attempts) => onComplete({ success: true, attempts })} />;
}

